module.exports = __webpack_public_path__ + "static/media/artist_05.b6a36e9c.png";